import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import CONSTANTS from '../../constants';
import utils from '../../utils';
import UrlDrivenAppDisplay from '../../components/UrlDrivenAppDisplay';
import ListSkeletonLoader from '../../components/Layout/ListSkeletonLoader';
import NavUtils from '../../NavUtils';
import { useHistory } from 'react-router';



function CEORTAppPage({ tenant }) {

  const history = useHistory();
  let hasAccess = NavUtils.hasAppAccess(tenant, CONSTANTS.APPS_BY_APPTYPE.NTD_CEO_RT);

  if(!hasAccess) {
      history.push('/');
  }

  let [contentModel, setContentModel] = useState();
  let [navDescr, setNavDescr] = useState();
  let [loading, setLoading] = useState(true);
  const { user, getAccessTokenSilently } = useAuth0();

  let tenantSlug = tenant.tenant.fields.tenantslug;

  let tenID = utils.getForceTenantValue();

  if (!tenID) {
    //if no currently set forceTenantValue, get the id from the agility record, and set it in localstorage
    tenID = tenant.tenant.fields.aDGroupID || null;
    utils.setForceTenantValue(tenID);
  }


  const trackCall = async (accToken, appType) => {
    //no await on purpose, we don't need to ensure that it returns - just issue it
    utils.trackAppView(appType, tenID, accToken);
  }


  const getContentModel = async (token) => {
    let extraParams = 'force_id=' + tenant.tenant.fields.aDGroupID;

    let jsonresponse = await utils.getTenantContent(token, CONSTANTS.APPS_BY_APPTYPE.NTD_CEO_RT, tenantSlug, tenant.ourUserID, extraParams);

    let apiKey = await utils.getAPIKey(token);
    let response = await utils.getAppNavItems('get_app_blueprint_b2c', CONSTANTS.APPS_BY_APPTYPE.NTD_CEO_RT, token.accessToken, apiKey, false); 
    let orderedNavs = utils.orderNavItems(response);
    setNavDescr(orderedNavs);

    setContentModel(jsonresponse.content);

    setLoading(false);
  }

  useEffect(() => {
    try {
      (async () => {
        let accToken = await utils.getAccessToken(getAccessTokenSilently, user);
        // only track if on prod
        if(process.env.REACT_APP_ENV === 'PROD' ) {
          trackCall(accToken, CONSTANTS.APPS_BY_APPTYPE.NTD_CEO_RT);
        }
        getContentModel(accToken);
      })()
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    // eslint-disable-next-line
  }, []);

  return (
    !loading ?
      contentModel ?
        <div className='url-driven-app round-table-app'>
          <UrlDrivenAppDisplay
            tenant={tenant}
            content={contentModel[0]}
            navs={navDescr}
            appType={ CONSTANTS.APPS_BY_APPTYPE.NTD_CEO_RT }
            defaultPage="exec_summary"
            displayFieldName={"toolName"}
            hasSubItems={null} />
        </div>
        : <div>Content Model Not Found</div>
      : <ListSkeletonLoader preview={false} />

  )
}

export default CEORTAppPage;
